import { render, staticRenderFns } from "./pagination-secondary.vue?vue&type=template&id=20f48ddc&scoped=true&"
import script from "./pagination-secondary.vue?vue&type=script&lang=js&"
export * from "./pagination-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f48ddc",
  null
  
)

export default component.exports